/**
 * @generated SignedSource<<d9f1096a28ae1e3341bbf8462897a3ab>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type ModelGeneration3DInput = {
  addons?: string | null;
  animationActionId?: number | null;
  bboxCondition?: ReadonlyArray<number> | null;
  enableAnimation?: boolean | null;
  enablePBR: boolean;
  enablePromptExpansion?: boolean | null;
  enableRigging?: boolean | null;
  faceCount: number;
  geometryFileFormat?: string | null;
  imageUrl?: string | null;
  material?: string | null;
  mode: string;
  model: string;
  multiViewImages?: ReadonlyArray<ModelGeneration3DViewImageInput> | null;
  poseMode?: string | null;
  previewRender?: boolean | null;
  prompt?: string | null;
  qualityMeshOption?: string | null;
  riggingHeightMeters?: number | null;
  saveToLibrary: boolean;
  seed?: number | null;
  shouldRemesh?: boolean | null;
  shouldTexture?: boolean | null;
  symmetryMode?: string | null;
  taPose?: boolean | null;
  textureImageUrl?: string | null;
  texturePrompt?: string | null;
  topology?: string | null;
  useOriginalAlpha?: boolean | null;
};
export type ModelGeneration3DViewImageInput = {
  viewImageUrl?: string | null;
  viewType?: string | null;
};
export type tasksStartModelGeneration3DMutation$variables = {
  input: ModelGeneration3DInput;
};
export type tasksStartModelGeneration3DMutation$data = {
  readonly startModelGeneration3D: {
    readonly createdAt: string;
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  };
};
export type tasksStartModelGeneration3DMutation = {
  response: tasksStartModelGeneration3DMutation$data;
  variables: tasksStartModelGeneration3DMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ModelGeneration3DTask",
    "kind": "LinkedField",
    "name": "startModelGeneration3D",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tasksStartModelGeneration3DMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "tasksStartModelGeneration3DMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "982babc0f0e744619f63ba3238abcf38",
    "id": null,
    "metadata": {},
    "name": "tasksStartModelGeneration3DMutation",
    "operationKind": "mutation",
    "text": "mutation tasksStartModelGeneration3DMutation(\n  $input: ModelGeneration3DInput!\n) {\n  startModelGeneration3D(input: $input) {\n    taskId\n    state\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9602bc6600ee7c8da4f1139ee54147e";

export default node;
